module.exports = __webpack_public_path__ + "img/8_logo.92a1b064.svg";